import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateRecentlyUsedContentTypes($contentType: String!) {
    updateRecentlyUsedContentTypes(contentType: $contentType)
  }
`;

interface Params {
  contentType: string;
}

export const updateRecentlyUsedContentTypes = async ({
  contentType,
}: Params): Promise<string[]> => {
  const variables = { contentType };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<string[]>(response.data) || [];
};
